export default __webpack_public_path__ + "static/material_06-78a423269d11a2c6ca1fb963287ffa0c.png";